<div class="main">
    <div *ngIf="showLoader" class="loader">
        <div class="load">
            <mat-spinner></mat-spinner>
        </div>
    </div>
    <div class="section">
        <div class="header">
            <div class="title">
                <div class="label">
                    {{'MYSHIPPERS.myShippers' | translate}}
                </div>
                <div class="help">
                  <!-- <app-help [helpData]="helpData" ></app-help> -->
                </div>
              </div>
            
        </div>
        <div class="pendingInvites">
            <div class="header">
                {{'MYSHIPPERS.pendingInvite' | translate}}
            </div>
            <div class="invites">
                <div *ngFor="let invite of pendingInvites">
                    <div class="invite">
                        <div class="name">{{invite.shipper.parent_name}} - {{invite.shipper.name}}</div>
                        <div class="actions">
                            <div class="submitButton">
                                <div class="button" (click)="inviteShipper(invite, true)">
                                    {{'MYSHIPPERS.acceptInvite' | translate}}
                                </div>
                            </div>
                            <div class="submitButton">
                                <div class="button reject" (click)="inviteShipper(invite, false)">
                                    {{'MYSHIPPERS.rejectInvite' | translate}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="table">
            <table mat-table *ngIf="shippersArr.length;else noShippers;" [dataSource]="shippersArr">
                <ng-container matColumnDef="sNo">
                    <th mat-header-cell *matHeaderCellDef> {{'MYSHIPPERS.sNo' | translate}} </th>
                    <td mat-cell *matCellDef="let row"> {{row.sNo}} </td>
                </ng-container>
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef> {{'MYSHIPPERS.name' | translate}} </th>
                    <td mat-cell *matCellDef="let row">{{row.parent_name}} - {{row.name}} </td>
                </ng-container>
                <ng-container matColumnDef="address">
                    <th mat-header-cell *matHeaderCellDef> {{'MYSHIPPERS.address' | translate}} </th>
                    <td mat-cell *matCellDef="let row"> {{row.address}} </td>
                </ng-container>
                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef> {{'MYSHIPPERS.action' | translate}} </th>
                    <td mat-cell *matCellDef="let row"> 
                        <div class="submitButton">
                            <div class="button">
                                {{'MYSHIPPERS.addToQbo' | translate}}
                            </div>
                        </div>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="shipperColumn; sticky: true;"></tr>
                <tr mat-row *matRowDef="let row; columns: shipperColumn;"></tr>
            </table>
        </div>
        <ng-template #noShippers>
          <div class="noShippers">
            {{'MYSHIPPERS.noShippers' | translate}}
          </div>
        </ng-template>
    </div>
</div>